// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFeeModificationDto } from './IFeeModificationDto';
import {
    IFeeModificationDtoFromJSON,
    IFeeModificationDtoFromJSONTyped,
    IFeeModificationDtoToJSON,
    IFeeModificationDtoToJSONTyped,
} from './IFeeModificationDto';
import type { IActivityDetail } from './IActivityDetail';
import {
    IActivityDetailFromJSON,
    IActivityDetailFromJSONTyped,
    IActivityDetailToJSON,
    IActivityDetailToJSONTyped,
} from './IActivityDetail';
import type { IFeeDto } from './IFeeDto';
import {
    IFeeDtoFromJSON,
    IFeeDtoFromJSONTyped,
    IFeeDtoToJSON,
    IFeeDtoToJSONTyped,
} from './IFeeDto';

/**
 * 
 * @export
 * @interface IBankingActivityDetails
 */
export interface IBankingActivityDetails {
    /**
     * 
     * @type {number}
     * @memberof IBankingActivityDetails
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    metadata?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    transaction_type?: IBankingActivityDetailsTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IBankingActivityDetails
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IBankingActivityDetails
     */
    posting_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IBankingActivityDetails
     */
    status_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IBankingActivityDetails
     */
    authorization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankingActivityDetails
     */
    tax_year?: string;
    /**
     * 
     * @type {Array<IFeeDto>}
     * @memberof IBankingActivityDetails
     */
    fees?: Array<IFeeDto>;
    /**
     * 
     * @type {Array<IFeeModificationDto>}
     * @memberof IBankingActivityDetails
     */
    fee_modifications?: Array<IFeeModificationDto>;
    /**
     * 
     * @type {Array<IActivityDetail>}
     * @memberof IBankingActivityDetails
     */
    activity_details?: Array<IActivityDetail>;
    /**
     * 
     * @type {Array<IActivityDetail>}
     * @memberof IBankingActivityDetails
     */
    activity_details_v2?: Array<IActivityDetail>;
}

/**
* @export
* @enum {string}
*/
export enum IBankingActivityDetailsTransactionTypeEnum {
    NOTIONAL_FUND = 'NOTIONAL_FUND',
    REPLENISHMENT_PAYMENT = 'REPLENISHMENT_PAYMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    PAY_CLAIM = 'PAY_CLAIM',
    CHECK_CLEARED = 'CHECK_CLEARED',
    CARD_PROCESSOR_PAYMENT = 'CARD_PROCESSOR_PAYMENT',
    RECORD_KEEPING_PAYROLL = 'RECORD_KEEPING_PAYROLL',
    CONTRIBUTION_PAYMENT = 'CONTRIBUTION_PAYMENT',
    PAYROLL = 'PAYROLL',
    EMPLOYER_PAYMENT = 'EMPLOYER_PAYMENT',
    PAYMENT = 'PAYMENT',
    INTEREST = 'INTEREST',
    FEE = 'FEE',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INVESTMENT = 'INVESTMENT',
    ACH_CLEARED = 'ACH_CLEARED',
    DEBIT_CLEARED = 'DEBIT_CLEARED',
    VENMO_CLEARED = 'VENMO_CLEARED',
    PAYPAL_CLEARED = 'PAYPAL_CLEARED',
    ADJUSTMENT = 'ADJUSTMENT',
    INTEREST_PAYMENT = 'INTEREST_PAYMENT',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    BUY_INVESTMENT_CLEARED = 'BUY_INVESTMENT_CLEARED',
    SELL_INVESTMENT_CLEARED = 'SELL_INVESTMENT_CLEARED',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    LOCKBOX_PAYMENT = 'LOCKBOX_PAYMENT',
    PAYMENT_CARD_RETURN = 'PAYMENT_CARD_RETURN',
    ROLLOVER = 'ROLLOVER',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    DEBIT_VENMO_PAYPAL_REJECTED = 'DEBIT_VENMO_PAYPAL_REJECTED',
    RETURN_REPLENISHMENT_PAYMENT = 'RETURN_REPLENISHMENT_PAYMENT',
    RECORD_KEEPING = 'RECORD_KEEPING',
    CONTRIBUTION_PAID = 'CONTRIBUTION_PAID',
    PREFUND_REPLENISHMENT = 'PREFUND_REPLENISHMENT',
    INTERNAL_TRANSFER_OF_ASSETS = 'INTERNAL_TRANSFER_OF_ASSETS',
    HSA_INCOMING_CONTRIBUTION = 'HSA_INCOMING_CONTRIBUTION',
    HSA_ROLLOVER = 'HSA_ROLLOVER',
    ORPHAN_EE_FEE = 'ORPHAN_EE_FEE',
    ORPHAN_EE_FEE_PAYMENT = 'ORPHAN_EE_FEE_PAYMENT',
    ADMIN_FEE = 'ADMIN_FEE',
    ADMIN_FEE_PAYMENT = 'ADMIN_FEE_PAYMENT',
    REPLENISHMENT_REVERSE = 'REPLENISHMENT_REVERSE',
    ACH_REJECTED = 'ACH_REJECTED',
    RETURN_CONTRIBUTION_PAYMENT = 'RETURN_CONTRIBUTION_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_REVERSE = 'HSA_INCOMING_CONTRIBUTION_REVERSE',
    HSA_ROLLOVER_REVERSE = 'HSA_ROLLOVER_REVERSE',
    INVESTMENT_FEES = 'INVESTMENT_FEES',
    REPLENISHMENT_FUNDING_REVERSE = 'REPLENISHMENT_FUNDING_REVERSE',
    RETURN_REPLENISHMENT_FUNDING_PAYMENT = 'RETURN_REPLENISHMENT_FUNDING_PAYMENT',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_TRANSFER_INTERNAL = 'CLAIM_TRANSFER_INTERNAL',
    PAYROLL_REVERSE = 'PAYROLL_REVERSE',
    CONTRIBUTION_PAID_REVERSE = 'CONTRIBUTION_PAID_REVERSE',
    CONTRIBUTION_REVERSE_PAYMENT = 'CONTRIBUTION_REVERSE_PAYMENT',
    PREFUND_REPLENISHMENT_RETURN = 'PREFUND_REPLENISHMENT_RETURN',
    FINAL_PREFUND_REPLENISHMENT_RETURN = 'FINAL_PREFUND_REPLENISHMENT_RETURN',
    PREFUND_PAYMENT = 'PREFUND_PAYMENT',
    PREFUND_INTER = 'PREFUND_INTER',
    RETURN_PREFUND_FUNDING_PAYMENT = 'RETURN_PREFUND_FUNDING_PAYMENT',
    PREFUND_FINAL = 'PREFUND_FINAL',
    PREFUND_FUNDING_REVERSE = 'PREFUND_FUNDING_REVERSE',
    RETURN_LOCKBOX = 'RETURN_LOCKBOX',
    INBOUND_CHECK_CLEARED = 'INBOUND_CHECK_CLEARED',
    LOCKBOX_INCOMING = 'LOCKBOX_INCOMING',
    INBOUND_TRANSFER_OF_ASSETS = 'INBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_TRANSFER_OF_ASSETS = 'OUTBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_CHECK_CLEARED = 'OUTBOUND_CHECK_CLEARED',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    WRITE_OFF = 'WRITE_OFF',
    FORFEITURE = 'FORFEITURE',
    PUSH_REPLENISHMENT_PAYMENT = 'PUSH_REPLENISHMENT_PAYMENT',
    PUSH_PREFUND_PAYMENT = 'PUSH_PREFUND_PAYMENT',
    PUSH_CONTRIBUTION_PAYMENT = 'PUSH_CONTRIBUTION_PAYMENT',
    PAYMENT_EE_FEE = 'PAYMENT_EE_FEE',
    ACCOUNT_MAINTENANCE_EE_FEE = 'ACCOUNT_MAINTENANCE_EE_FEE',
    PAPER_STATEMENT_EE_FEE = 'PAPER_STATEMENT_EE_FEE',
    EE_FEES_BULK_PAYMENT = 'EE_FEES_BULK_PAYMENT',
    OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS = 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS',
    FEE_TRANSFER_INTERNAL = 'FEE_TRANSFER_INTERNAL',
    FEE_TRANSFER = 'FEE_TRANSFER',
    CLAIM_REJECTION = 'CLAIM_REJECTION',
    ACH_CLAIM_REPAYMENT = 'ACH_CLAIM_REPAYMENT',
    ACH_CLAIM_REPAYMENT_REJECTED = 'ACH_CLAIM_REPAYMENT_REJECTED',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_REPAYMENT_TRANSFER_INTERNAL = 'CLAIM_REPAYMENT_TRANSFER_INTERNAL',
    CLAIM_REPAYMENT_TRANSFER = 'CLAIM_REPAYMENT_TRANSFER',
    LOCKBOX_CHECK_CLEARED = 'LOCKBOX_CHECK_CLEARED',
    LOCKBOX_CLAIM_REPAYMENT = 'LOCKBOX_CLAIM_REPAYMENT',
    NOTIONAL_CONTRIBUTION_PAID = 'NOTIONAL_CONTRIBUTION_PAID',
    PREFUND_RETURN_PAYMENT_REVERSE = 'PREFUND_RETURN_PAYMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    NOTIONAL_CONTRIBUTION_PAID_REVERSE = 'NOTIONAL_CONTRIBUTION_PAID_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT',
    EOY_PLAN_FUNDS_INTERNAL_RETURN = 'EOY_PLAN_FUNDS_INTERNAL_RETURN',
    PUSH_RETURN_PAYMENT = 'PUSH_RETURN_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_PAYMENT = 'HSA_INCOMING_CONTRIBUTION_PAYMENT',
    NOTIONAL_PAYROLL_REVERSE = 'NOTIONAL_PAYROLL_REVERSE',
    EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION = 'EOY_PLAN_SHORTAGE_COLLECTION',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT',
    PUSH_UNKNOWN_PAYMENT = 'PUSH_UNKNOWN_PAYMENT',
    UNMATCHED_PUSH_KEEPING = 'UNMATCHED_PUSH_KEEPING',
    PUSH_INVOICE_PAYMENT = 'PUSH_INVOICE_PAYMENT',
    UNMATCHED_PUSH_RETURN = 'UNMATCHED_PUSH_RETURN',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL',
    ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS = 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL',
    BULK_BALANCE_ADJUSTMENT = 'BULK_BALANCE_ADJUSTMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE',
    BULK_BALANCE_ADJUSTMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'
}


/**
 * Check if a given object implements the IBankingActivityDetails interface.
 */
export function instanceOfIBankingActivityDetails(value: object): value is IBankingActivityDetails {
    return true;
}

export function IBankingActivityDetailsFromJSON(json: any): IBankingActivityDetails {
    return IBankingActivityDetailsFromJSONTyped(json, false);
}

export function IBankingActivityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBankingActivityDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'category': json['category'] == null ? undefined : json['category'],
        'transaction_type': json['transaction_type'] == null ? undefined : json['transaction_type'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'posting_id': json['posting_id'] == null ? undefined : json['posting_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'status_date': json['status_date'] == null ? undefined : (new Date(json['status_date'])),
        'authorization_id': json['authorization_id'] == null ? undefined : json['authorization_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(IFeeDtoFromJSON)),
        'fee_modifications': json['fee_modifications'] == null ? undefined : ((json['fee_modifications'] as Array<any>).map(IFeeModificationDtoFromJSON)),
        'activity_details': json['activity_details'] == null ? undefined : ((json['activity_details'] as Array<any>).map(IActivityDetailFromJSON)),
        'activity_details_v2': json['activity_details_v2'] == null ? undefined : ((json['activity_details_v2'] as Array<any>).map(IActivityDetailFromJSON)),
    };
}

export function IBankingActivityDetailsToJSON(json: any): IBankingActivityDetails {
    return IBankingActivityDetailsToJSONTyped(json, false);
}

export function IBankingActivityDetailsToJSONTyped(value?: IBankingActivityDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'memo': value['memo'],
        'metadata': value['metadata'],
        'category': value['category'],
        'transaction_type': value['transaction_type'],
        'employee_id': value['employee_id'],
        'posting_id': value['posting_id'],
        'status': value['status'],
        'status_date': value['status_date'] == null ? undefined : ((value['status_date']).toISOString()),
        'authorization_id': value['authorization_id'],
        'plan_name': value['plan_name'],
        'external_identifier': value['external_identifier'],
        'tax_year': value['tax_year'],
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(IFeeDtoToJSON)),
        'fee_modifications': value['fee_modifications'] == null ? undefined : ((value['fee_modifications'] as Array<any>).map(IFeeModificationDtoToJSON)),
        'activity_details': value['activity_details'] == null ? undefined : ((value['activity_details'] as Array<any>).map(IActivityDetailToJSON)),
        'activity_details_v2': value['activity_details_v2'] == null ? undefined : ((value['activity_details_v2'] as Array<any>).map(IActivityDetailToJSON)),
    };
}

